export default "__VITE_ASSET__Dck5Wm8K__"